import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation, useNavigationType } from "react-router-dom";
import { useEffect } from "react";
import Home from "@/pages/Home";
import PartsChecklist from "@/pages/PartsChecklist";
import StepPage from "@/pages/StepPage";
import Done from "@/pages/Done";
import VideoInstructions from "@/pages/VideoInstructions";
import VolunteerSelect from "@/pages/VolunteerSelect";
import FlowPage from "@/pages/FlowPage";
import DesignInstructions from "@/pages/DesignInstructions";
import FinalPacking from "@/pages/FinalPacking";
import TeamUp from "@/pages/TeamUp";
import Discuss from "@/pages/Discuss";

function ScrollToTop() {
  const { pathname } = useLocation();
  const navType = useNavigationType();
  useEffect(() => {
    // On browser back/forward, let the browser restore the previous scroll position.
    if (navType === "POP") return;
    window.scrollTo(0, 0);
  }, [pathname, navType]);
  return null;
}

function ThemeSwitcher() {
  const { pathname } = useLocation();
  useEffect(() => {
    const isHome = pathname === "/";
    document.body.classList.toggle("theme-arcade", !isHome);
    return () => document.body.classList.remove("theme-arcade");
  }, [pathname]);
  return null;
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <ThemeSwitcher />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/checklist" element={<PartsChecklist />} />
          <Route path="/discuss" element={<Discuss />} />
          <Route path="/select-volunteer" element={<VolunteerSelect />} />
          <Route path="/v/:volunteer" element={<FlowPage />} />
          <Route path="/v/:volunteer/steps" element={<FlowPage />} />
          <Route path="/v/:volunteer/:index" element={<FlowPage />} />
          <Route path="/step/:no" element={<StepPage />} />
          <Route path="/done" element={<Done />} />
          <Route path="/video" element={<VideoInstructions />} />
          <Route path="/design" element={<DesignInstructions />} />
          <Route path="/final-packing" element={<FinalPacking />} />
          <Route path="/team-up" element={<TeamUp />} />
          {/* Legacy route — redirect to the new step-by-step flow */}
          <Route path="/picture" element={<Navigate to="/checklist" replace />} />
          <Route path="/connect" element={<Navigate to="/final-packing" replace />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
